import * as yup from 'yup'

const requiredMessage = 'This field is required.'

export interface IShipmentDispatcher {
  id: string
  shipperId?: string
  carrierId?: string
  firstName?: string
  lastName?: string
  fullName?: string
}

export const DispatcherSchema = yup.object<IShipmentDispatcher>({
  id: yup.string().required(requiredMessage),
  fullName: yup.string(),
})
